/* @flow strict */

import * as React from 'react';
import { format } from '/client/src/utils/amountTransformation';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import { currency } from '/client/src/constants/';

export const columns = (): [] => {
  const context = React.useContext(EventDetailContainerContext);
  const _currency = context.eventDetail.default_currency;

  return [
    {
      selector: 'name',
      name: 'Ticket Type',
      sortable: true
    },
    {
      selector: 'price',
      name: 'Price',
      sortable: true,
      cell: (row: {}): void => (<span>{format(currency[_currency], row.price)}</span>)
    },
    {
      selector: 'sold_quantity',
      name: 'Guests count',
      sortable: true
    }
  ];
};
